import ContinuePage from "@components/ContinuePage"

export default function CarsDoingGreatPage() {
  return <ContinuePage emoji="💪" translationKey="carsDoingGreat" />
}
